import { City } from "./City.model";
import { RequestModel} from "./Request.model";

export class RequestLocationModel {
    public CreatedBy: string;
    public CreatedDate: Date;
    public Id: number;
    public IdCity: number;
    public IdCityGeo: string;
    public IdCityNavigation: City;
    public IdRequest: number;
    public IdLanguage: string;
    public LanguageName: string;
    public IdCountry: string;
    public CountryName: string;
    public CityId: string;
    public CityName: string;
    public StateName: string;
    public RegionName: string;
    public EmittingPlateName: string;
    public CityCode: string;
    public ModifiedBy: string;
    public ModifiedDate: Date;
    public IdRequestNavigation: RequestModel[];
}
